import type { Review } from '../types/product';

/**
 * PLACEHOLDER REVIEWS — replace with real, verifiable buyer reviews before publishing.
 * Publishing invented testimonials can breach consumer-protection rules (e.g. the US FTC rule on fake reviews).
 */
export const reviews: Review[] = [
  {
    initials: 'JM',
    name: 'Jennifer M.',
    role: 'Bach Flower practitioner',
    location: 'Oregon, USA',
    accent: 'rose',
    text: 'Having the consultation framework, record pages, and reflection prompts in one place has made my session prep so much calmer. I keep Volume I open on my tablet.',
  },
  {
    initials: 'SH',
    name: 'Sarah H.',
    role: 'Holistic therapist',
    location: 'Bristol, UK',
    accent: 'violet',
    text: 'The formula studies are clearly framed as educational examples, which I appreciate. The case studies helped me compare similar emotional descriptions much more carefully.',
  },
  {
    initials: 'LT',
    name: 'Laura T.',
    role: 'Bach Flower student',
    location: 'Melbourne, Australia',
    accent: 'amber',
    text: 'Beautifully designed and easy to navigate. The Business Masterclass gave me a simple structure to plan my services for the next 90 days.',
  },
];
